import React from 'react';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { ResearchEntry } from 'site-modules/editorial/components/about-article/research-entry/research-entry';
import {
  COPYRIGHT_TRADEMARK_BREADCRUMBS,
  COPYRIGHT_TRADEMARK_CONTENT_PATH,
} from 'site-modules/editorial/constants/about';
import { edmundsLogoHalfCarLeft } from 'client/images/inline-svgs/edmunds-logo';

import './copyright-trademark.scss';

function CopyrightTrademarkUI({ content = null }) {
  if (!content) {
    return null;
  }

  const mainEntries = content.child('main').children();

  return (
    <div className="copyright-trademark pb-3_5 pos-r">
      <div className="bg-logo w-100 top-0 pos-a bg-gray-lightest">
        {edmundsLogoHalfCarLeft({ className: 'logo pos-a right-0 top-0', width: null, fill: '#FFFFFF' })}
      </div>
      <Container tag="main" id="main-content" tabIndex={-1}>
        <Breadcrumbs className="px-0 mb-3_5 pb-1_5" data={COPYRIGHT_TRADEMARK_BREADCRUMBS} />
        <Row>
          <Col xs={12} lg={8} className="mb-1_5 mb-lg-0">
            {/* main */}
            {mainEntries.map((entry, index) => {
              const key = `main-${entry.id}-${index}`;

              return <ResearchEntry key={key} entry={entry} />;
            })}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

CopyrightTrademarkUI.propTypes = {
  content: CmsEntities.Content,
};

export const CopyrightTrademark = connectToModel(CopyrightTrademarkUI, {
  content: bindToContent(COPYRIGHT_TRADEMARK_CONTENT_PATH),
});
